var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96447 3.13121C7.90215 2.19353 9.17392 1.66675 10.5 1.66675H23.8333C24.2754 1.66675 24.6993 1.84234 25.0118 2.1549L35.0118 12.1549C35.3244 12.4675 35.5 12.8914 35.5 13.3334V33.3334C35.5 34.6595 34.9732 35.9313 34.0355 36.8689C33.0979 37.8066 31.8261 38.3334 30.5 38.3334H10.5C9.17392 38.3334 7.90215 37.8066 6.96447 36.8689C6.02678 35.9313 5.5 34.6595 5.5 33.3334V6.66675C5.5 5.34067 6.02678 4.0689 6.96447 3.13121ZM10.5 5.00008C10.058 5.00008 9.63405 5.17568 9.32149 5.48824C9.00893 5.8008 8.83333 6.22472 8.83333 6.66675V33.3334C8.83333 33.7754 9.00893 34.1994 9.32149 34.5119C9.63405 34.8245 10.058 35.0001 10.5 35.0001H30.5C30.942 35.0001 31.3659 34.8245 31.6785 34.5119C31.9911 34.1994 32.1667 33.7754 32.1667 33.3334V14.0238L23.143 5.00008H10.5Z",
    fill: "#4A0DFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8333 1.66675C24.7538 1.66675 25.5 2.41294 25.5 3.33341V11.6667H33.8333C34.7538 11.6667 35.5 12.4129 35.5 13.3334C35.5 14.2539 34.7538 15.0001 33.8333 15.0001H23.8333C22.9129 15.0001 22.1667 14.2539 22.1667 13.3334V3.33341C22.1667 2.41294 22.9129 1.66675 23.8333 1.66675Z",
    fill: "#4A0DFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 18.3334C21.4205 18.3334 22.1667 19.0796 22.1667 20.0001V30.0001C22.1667 30.9206 21.4205 31.6667 20.5 31.6667C19.5795 31.6667 18.8333 30.9206 18.8333 30.0001V20.0001C18.8333 19.0796 19.5795 18.3334 20.5 18.3334Z",
    fill: "#4A0DFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8333 25.0001C13.8333 24.0796 14.5795 23.3334 15.5 23.3334H25.5C26.4205 23.3334 27.1667 24.0796 27.1667 25.0001C27.1667 25.9206 26.4205 26.6667 25.5 26.6667H15.5C14.5795 26.6667 13.8333 25.9206 13.8333 25.0001Z",
    fill: "#4A0DFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/addFile.8b3cdbddd70e62ea2bf8879246d57edc.svg";
export { ForwardRef as ReactComponent };